import { render } from "./ManagersTable.vue?vue&type=template&id=6b7e7950&scoped=true"
import script from "./ManagersTable.vue?vue&type=script&lang=js"
export * from "./ManagersTable.vue?vue&type=script&lang=js"

import "./ManagersTable.vue?vue&type=style&index=0&id=6b7e7950&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b7e7950"]])

export default __exports__